import React from 'react'
import Subscribe from './Subscribe'

export default function Team() {
  return (
    <div className='bg-grey-vlight pt-16'>
      <div className='w-11/12 mx-auto 2xl:max-w-[1200px]'>
        <h1 className='f-f-r text-2xl text-black'>Hey there!</h1>
        <p className='f-f-r text-2xl text-black'>
I'm thrilled to share the story behind Rapido Relief with you. Picture this: it all started with a simple idea – to make healthcare more accessible, efficient, and downright human. <br /><br />

At Rapido Relief, we're not your typical healthcare company. Nope, we're all about breaking down barriers and putting people first. You see, I've always believed that everyone deserves quality healthcare, no matter who they are or where they live. <br /><br />

So, armed with a passion for innovation and a team of incredible minds, we set out on a mission. Our goal? To revolutionize the way healthcare is delivered, one brilliant idea at a time. <br /><br />

But here's the kicker: we're not just in it for the fancy tech or the big bucks (although those are nice too, don't get me wrong). No, what really drives us is the chance to make a real difference in people's lives. Whether it's helping a patient find the right doctor or making sure they get their meds on time, every little victory is a win in our book. <br /><br />

And hey, we're not ones to toot our own horn, but we've come a long way since those early days. Today, Rapido Relief is a trusted name in healthcare, known for our innovative solutions and unwavering commitment to our community. <br /><br />

But enough about us – we want to hear from you! Whether you're a patient looking for help or a provider ready to join the revolution, we're here to make your healthcare journey a breeze. <br /><br />

So go ahead, take a leap of faith with us. Who knows? Together, we just might change the world. <br /> <br />

Catch you on the flip side,

<h2 className='text-black text-10xl f-f-w'>Michael Tosin Adesanwo</h2>

Founder, Rapido Relief</p>


      </div>
      <Subscribe/>
    </div>
  )
}